import _omit from 'lodash/omit'
import _isEmpty from 'lodash/isEmpty'

export const isLastIndex = (index, length) => index === length - 1

export const paginate = (array = [], pageNumber = 1, offset = 3) => {
  if (!Array.isArray(array)) return []
  return array.slice((pageNumber - 1) * offset, pageNumber * offset)
}

export const loadMore = (array = [], pageNumber = 1, offset = 5) => {
  if (!Array.isArray(array)) return []
  return array.slice(0, pageNumber * offset)
}

export const omitPropertiesOnArray = (array, properties = []) => array?.map?.(obj => _omit(obj, properties))

export const removeEmptyPropertiesFromObject = object =>
  Object.entries(object || {}).filter(([_, value]) => !_isEmpty(value))
